import React, { useEffect, useState } from 'react'
import { Drawer, Box, Button } from '@mui/material'

import givewiseLogo from './givewise-logo-wordmark.png'
import { useUserIsOnMobileApp } from '../hooks/useUserIsOnMobileApp'
import { Text } from '../components'

function SplashScreen() {
  const [open, setOpen] = useState(false)
  const isOnMobileApp = useUserIsOnMobileApp()

  useEffect(() => {
    if (isOnMobileApp) {
      const hasSession = sessionStorage.getItem('appSession')
      if (hasSession) {
        setOpen(false)
      } else {
        sessionStorage.setItem('appSession', 'true')
        setOpen(true)
        setTimeout(() => setOpen(false), 2000)
      }
    }
  }, [isOnMobileApp])

  return (
    <Drawer
      anchor="bottom"
      open={open}
      variant="persistent"
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        '& .MuiDrawer-paper': {
          height: '100%',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          padding: 2,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 4,
            width: '100%',
            maxWidth: '500px',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src={givewiseLogo}
              alt="GiveWise Logo"
              style={{
                width: '100%',
                maxWidth: '200px',
                display: 'block',
                margin: '0 auto',
              }}
            />
          </Box>
        </Box>

        {/* Content */}
        <Box
          sx={{
            marginBottom: 2,
            maxWidth: '500px',
            textAlign: 'center',
          }}
        >
          <Text.Bold>Welcome to the GiveWise Mobile App!</Text.Bold>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            maxWidth: '500px',
            margin: '0 auto',
            textAlign: 'left',
            padding: '0 24px',
          }}
        >
          <Text.Body>
            This App is for accessing basic functions of your Giving Fund, such as adding funds via credit card or a
            linked bank account, checking balances, or gifting out to charities.
          </Text.Body>
          <Text.Body>
            If you don&apos;t yet have a GiveWise Giving Fund, you can also use this App to sign up for one. It takes
            just 3 minutes!
          </Text.Body>
          <Text.Body>
            For more advanced functions such as downloading tax receipts or donating complex assets, please sign in to
            your Giving Fund on a computer browser.
          </Text.Body>
          <Text.Bold>Thanks for Growing Generosity together with us!</Text.Bold>
        </Box>

        {/* Action Button */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: 2,
            width: '100%',
            maxWidth: '500px',
            marginTop: 4,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(false)}
            sx={{
              width: '100%',
            }}
          >
            Proceed
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
}

export default SplashScreen
